
import { useFinanceiro, useSerieFinanceira } from './api/financeiro-api'
import { PainelDensoFinanceiro } from './painel-denso-financeiro'

import type { FiltroPeriodo } from '@/features/relatorio/api/relatorio-api'
import type { ReactElement } from 'react'

import { AvisoDesconectado } from '@/components/shared/aviso-desconectado'
import { ApresentacaoCarregando } from '@/features/apresentacao/apresentacao-carregando'

/** O painel financeiro denso buscando os próprios dados para a apresentação global. */
export function BlocoFinanceiroDenso({ periodo }: { periodo: FiltroPeriodo }): ReactElement {
  const { data: relatorio } = useFinanceiro(periodo)
  const { data: serie } = useSerieFinanceira(6)

  if (!relatorio) return <ApresentacaoCarregando titulo="Saúde Financeira" />

  // No telao, zeros pareceriam resultado: melhor dizer que a fonte esta fora.
  // : payload de cache antigo (sem o campo) nao pode virar aviso.
  if (relatorio.disponivel === false) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
        <p className="text-lg font-medium">Saúde Financeira indisponível</p>
        <p className="text-muted-foreground text-base">{relatorio.motivo || 'Integração da Conta Azul fora do ar.'}</p>
      </div>
    )
  }

  return (
    <div className="flex h-full flex-col gap-3">
      {/* Fonte fora com snapshot: o telao mostra os numeros com a data em cima,
          senao a plateia leria dado velho como o de agora. */}
      {relatorio.desatualizado ? (
        <AvisoDesconectado
          fonte="Conta Azul"
          motivo={relatorio.motivo}
          coletadoEm={relatorio.coletadoEm}
        />
      ) : null}
      <div className="min-h-0 flex-1">
        <PainelDensoFinanceiro relatorio={relatorio} serie={serie} />
      </div>
    </div>
  )
}
